import { Outlet, Navigate, useNavigate } from "react-router-dom";
// import * as React from "react";
import { useContext, useEffect} from "react"
import AuthContext from "../store/auth/auth-context";
import Cookie from "js-cookie";
import useHttp from "../hooks/use-http";

const AuthValidate = () => {
  const navigate = useNavigate()
  const authCxt = useContext(AuthContext);
  const { isLoading, isError, message, sendRequest: authValidate } = useHttp();
  const accessToken = Cookie.get("accessToken");
  const refreshToken = Cookie.get("refreshToken");


  useEffect(()=>{
    authValidate({
      URL: "/api/authvalidate",
      method: "GET",
      header: {
        "Content-Type": "application/json",
      }
    },(res: any)=>{
      
      console.log('authvalidate',res, authCxt)
      if (res.isAuthError===true && !isLoading)
          authCxt.logout();

      if(res.authUserInfo)
      {
        authCxt.setUserInfo(res)
      }

    })
  },[])


  return (
     (accessToken && refreshToken) ? <Outlet />: <Navigate to="/login" />
    // (accessToken && refreshToken) ? children : <Navigate to="/login" />
  );

};

export default AuthValidate;


// import { Navigate } from 'react-router-dom';

// const AuthValidate = ({ children: any }) => {
//     const user = false;
//     if (!user) {
//         return <Navigate to="/login" replace />;
//     }
//     return children;
// };
// export default AuthValidate;
